import { inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { env } from "../env";

/**
 * Better Auth client pointed at the API origin (cookies: same-site siblings). The ONLY module
 * that imports `better-auth/*` (fitness rule): sign-in/out, the session, and the account
 * operations behind /profile all leave through here. Better Auth's `name` is the given name
 * (mapped onto first_name on the server); `lastName` is its additional field.
 */
export const authClient = createAuthClient({
  baseURL: env.VITE_API_URL,
  plugins: [
    inferAdditionalFields({
      user: {
        // Better Auth's own `name` is the given name; the surname is this additional field.
        lastName: { type: "string", required: true },
      },
    }),
  ],
});
export const {
  signIn,
  signOut,
  useSession,
  updateUser,
  changePassword,
  listSessions,
  revokeSession,
  revokeOtherSessions,
} = authClient;
